// react
import React, { useState, useEffect } from 'react';

// third-party
import PropTypes from 'prop-types';
// import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import Fade from 'react-reveal/Fade';

import Pagination from '../../shared/Pagination';
import VideoGaleryCard from './VideoGaleryCard';
import { getData } from '../../../services/fetch-service';
import PageTitle from '../../shared/PageTitle';
// import SkeletonGallery from '../../Skeletons/Skeleton-gallery';

function VideoGalery(props) {
    const url = window.location.pathname.split('/').pop();
    const { layout } = props;
    const { locale } = props;
    const params = useParams();
    const [page, setPage] = useState([]);
    const [post, setPost] = useState([]);
    const [totalPage, setTotalPage] = useState();
    const [CurrentPage, setCurrentPage] = useState();
    const [loader, setLoader] = useState(true);

    const handleChange = (skip = 0) => {
        getData(`Galery/GetGaleries?MediaGaleriaKategoriaID=2&PageID=${params.id}&Layout='default'&Gjuha=${locale}&skip=${skip}&take=10`).then((response) => {
            setPost(response.data.galeriaLista);
            setTotalPage(response.data.totalPages);
            setPage(response.data.page[0]);
            setLoader(false);
        });
    }
    useEffect(() => {
        handleChange();
    }, [url]);

    const handlePageChange = (CurrentPage) => {
        setCurrentPage(CurrentPage);
        const skip = (CurrentPage * 10) - 10;
        handleChange(skip);
    };

    const postsList = post.map((post, index) => {
        const postLayout = {
            classic: 'grid-lg',
            grid: 'grid-nl',
            list: 'list-nl',
        }[layout];

        return (
            <div key={index} className="posts-list__item galery-item">
                <VideoGaleryCard post={post} layout={postLayout} />
            </div>
        );
    });

    return (
        <React.Fragment>
            <PageTitle header={page.pageName} />
            <div className="block">
                <div className="posts-view">
                    <div className={`posts-view__list posts-list posts-list--layout--${layout}`}>
                        {
                            loader === true
                                ? (
                                    // <SkeletonGallery />
                                    ''
                                )
                                : (
                                    <Fade big>
                                        <div className="posts-list__body galery-body">
                                            {postsList}
                                        </div>
                                    </Fade>
                                )
                        }
                    </div>
                    {
                        post.length > 0 ? (
                            <div className="posts-view__pagination galery-pagination">
                                <Pagination
                                    current={CurrentPage}
                                    siblings={2}
                                    total={totalPage}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        ) : ('')
                    }
                </div>
            </div>
        </React.Fragment>
    );
}

VideoGalery.propTypes = {
    layout: PropTypes.oneOf(['classic', 'grid', 'list']),
};

VideoGalery.defaultProps = {
    layout: 'grid',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(VideoGalery);
